import { DownOutlined, EditOutlined } from '@ant-design/icons';
import { SubscriptionTabDefinition } from '@mm/state/helpers/billing-subscription-tab-helpers';
import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import modalActions from '@mm/state/modules/modalsState/actions';

import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Menu } from '../../../../../../../editor/features/beta/modules/Automations/AutomationEdit/DialogueEditor/NodeTypes/elements/NodeMenu/NodeMenu';
import { SettingsRoutes } from '../../../../../../../routes/settings-routes';
import { ManageSubsctiptionProps } from '../../../ManageSubsctiptionPanel/ManageSubsctiptionPanel';
import NewTeamAddPagesButton from './NewTeamAddPagesButton/NewTeamAddPagesButton';
import './TeamPlanButtonsArea.pcss';

type Props = {
  teamSubscription: SubscriptionModel;
  pages: ConnectedPageModel[];
  plan: EnhancedPlan;
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
  facebookPageId?: number;
  planTab: SubscriptionTabDefinition;
};

const useDropdownMenuList = (props: Props) => {
  const {
    teamSubscription,
    plan,
    pages,
    facebookPageId,
    searchInput,
    setSearchInput,
  } = props;
  const dispatch = useDispatch();

  return useMemo(() => {
    const openManagePagesModal = (
      subscription: SubscriptionModel,
      plan: EnhancedPlan,
      pagesCount: number,
    ) =>
      dispatch(
        modalActions.openManagePagesModal({
          subscription,
          plan,
          pagesCount,
          facebookPageId,
        }),
      );

    if (teamSubscription.state === 'canceled') {
      return [];
    }

    const manageItem = [
      {
        disabled: false,
        children: (
          <div className="team-plan-buttons-area__menu-item">
            {' '}
            <EditOutlined /> Manage slots
          </div>
        ),
        onClick: () =>
          openManagePagesModal(teamSubscription, plan, pages.length),
      },
      {
        disabled: false,
        children: (
          <div className="team-plan-buttons-area__menu-item">
            <NewTeamAddPagesButton
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              totalPages={pages.length}
              teamSubscription={teamSubscription}
              teamPlan={plan}
            />
          </div>
        ),
        onClick: () => {},
      },
    ];

    if (teamSubscription.pagesLimit) {
      return manageItem;
    }
    return [];
  }, [
    teamSubscription,
    plan,
    pages,
    facebookPageId,
    searchInput,
    setSearchInput,
    dispatch,
  ]);
};

export const TeamPlanButtonsArea = (props: Props) => {
  const { teamSubscription, pages, planTab, facebookPageId } = props;
  const openSlots = teamSubscription.pagesLimit
    ? teamSubscription.pagesLimit - pages.length
    : 0;
  const company = useSelector(activeCompanySelector);
  const dropdownMenuList = useDropdownMenuList(props);
  const isOwnerOrAdmin = company && company.editable;
  const history = useHistory();

  const data: ManageSubsctiptionProps = {
    accountName: company?.name,
  };

  return (
    <div className="team-plan-buttons-area">
      {!!dropdownMenuList.length && teamSubscription.pagesLimit !== null && (
        <Menu
          className="team-plan-buttons-area__more-dropdown"
          menu={dropdownMenuList}
          menuButton={
            <div className="team-plan-buttons-area__open-slots">
              {openSlots} open slots remaining
              <DownOutlined className="team-plan-buttons-area__open-slots-icon" />
            </div>
          }
          css={{
            menu: 'team-plan-buttons-area__more-dropdown-node-menu',
            action: 'team-plan-buttons-area__more-dropdown-node-menu-action',
          }}
        />
      )}
      {isOwnerOrAdmin && (
        <PrimaryButton
          className="billing-page-card__manage-plan-button"
          color="secondary-blue"
          onClick={() =>
            history.push(
              SettingsRoutes.billing.manageSubscrptions.getLink(
                planTab?.planCode,
                facebookPageId,
              ),
              { ...data },
            )
          }
        >
          Manage Plan
        </PrimaryButton>
      )}
    </div>
  );
};
